import { render, staticRenderFns } from "./SignatureEditor.vue?vue&type=template&id=4c2c162f&scoped=true&"
import script from "./SignatureEditor.vue?vue&type=script&lang=js&"
export * from "./SignatureEditor.vue?vue&type=script&lang=js&"
import style0 from "./SignatureEditor.vue?vue&type=style&index=0&id=4c2c162f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c162f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2c162f')) {
      api.createRecord('4c2c162f', component.options)
    } else {
      api.reload('4c2c162f', component.options)
    }
    module.hot.accept("./SignatureEditor.vue?vue&type=template&id=4c2c162f&scoped=true&", function () {
      api.rerender('4c2c162f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/SignatureEditor.vue"
export default component.exports